import { z } from "zod";

// Card and deliverable types
export const cardTypeSchema = z.enum(["JobInformation", "CartonInformation", "LabelInformation", "SystemInformation"]);

export const deliverableTypeSchema = z.enum(["Solution", "Carton", "Label", "Dim"]);
export type DeliverableType = z.infer<typeof deliverableTypeSchema>;

// Pipeline types
export const pipelineRuleTypeSchema = z.enum(["Conditional", "NonConditional"]);

// Label types
export const labelSourceSchema = z.enum(["Zpl", "ZplFromHeader", "Template"]);
export type LabelSource = z.infer<typeof labelSourceSchema>;

// Expression types
export const supportedExpressionOutputTypeSchema = z.enum(["String", "Number"]);

export const expressionTypeSchema = z.enum(["Unknown", "String", "Number"]);
export type ExpressionType = z.infer<typeof expressionTypeSchema>;

// String manipulation types
export const splitByCharacterCountStrategySchema = z.enum(["First", "Last", "Range"]);

export const padStringDirectionSchema = z.enum(["Left", "Right"]);

// Date/time types
export const dateTimeFormatSchema = z.enum([
	"DateTimeShort",
	"DateTimeLong",
	"DateShort",
	"DateLong",
	"TimeShort",
	"TimeLong",
	"Universal",
]);
export type DateTimeFormat = z.infer<typeof dateTimeFormatSchema>;

// Policy types
export const ignoreDuplicateWorkPolicySchema = z.enum(["Open", "OpenOrProduced"]);

// Condition operators
export const conditionOperatorSchema = z.enum([
	"GreaterThan",
	"GreaterThanOrEqual",
	"NumberEqual",
	"NumberNotEqual",
	"LessThan",
	"LessThanOrEqual",
	"TextEqual",
	"TextNotEqual",
	"TextEqualInsensitive",
	"TextNotEqualInsensitive",
	"TextContains",
	"TextContainsInsensitive",
	"TextNotContains",
	"TextNotContainsInsensitive",
]);
export type ConditionOperator = z.infer<typeof conditionOperatorSchema>;

// Pipeline action types
export const pipelineActionTypeSchema = z.enum([
	"SetValue",
	"AddCarton",
	"SwapValues",
	"DecodeBase64",
	"Undefined",
	"ClearValue",
	"WaitForTrigger",
	"ConvertDateTimeToEpoch",
	"Cube",
	"Dimensioning",
	"AddLabelToCarton",
	"TranslateData",
	"FailJob",
	"AddWalmartPrintImageFromCampaign",
	"AddCampaignPrintImageToCarton",
	"AddCartonV2",
	"AddStandaloneLabel",
	"ConvertToLocalTime",
	"SetLabelPosition",
	"AddPrintImage",
	"SplitStringByCharacterCount",
	"RoundValue",
	"PadString",
	"JoinStrings",
	"SortDimensions",
	"UpdateCartonDesign",
	"ExtractValue",
	"SplitStringByDelimiter",
	"IgnoreDuplicateWork",
	"ExtractDimValue",
	"ScalePrimaryCarton",
	"AddClosing",
	"GenerateRandomValue",
]);
export type PipelineActionType = z.infer<typeof pipelineActionTypeSchema>;

// Numeric types
export const roundValuePrecisionSchema = z.union([z.literal(0), z.literal(1), z.literal(2)]);
export type RoundValuePrecision = z.infer<typeof roundValuePrecisionSchema>;
